export const notificationTypes = {
  AG: 1,
};

export const notificationTypeToLabel = {
  [notificationTypes.AG]: 'Armazém Geral',
};

export const NOTIFICATION_OPTIONS = [
  {
    id: notificationTypes.AG,
    label: notificationTypeToLabel[notificationTypes.AG],
  },
];
